import * as React from 'react';
import {
    BooleanField,
    BooleanInput,
    Create,
    Edit,
    EditButton,
    List,
    NumberField,
    NumberInput,
    required,
    SimpleForm,
    TextField,
    TextInput
} from 'react-admin';
import AdminPagination from '../AdminPagination';
import AdminSelectableDatagrid from '../AdminSelectableDatagrid';
import HumanDeleteButton from '../HumanDeleteButton';
import HumanRecordTitle from '../HumanRecordTitle';

const filters = [
    <TextInput source="all" label="Recherche" alwaysOn />,
];

const OptionForm = () => (
    <>
        <TextInput source="name" label="Nom" validate={required()} fullWidth />
        <TextInput source="slug" label="Identifiant" validate={required()} />
        <TextInput source="description" label="Description" multiline rows={3} fullWidth />
        <TextInput
            source="pickup_locations"
            label="Points de retrait"
            helperText="Un point de retrait par ligne. Exemple : Île-de-France : Alfortville (94)"
            multiline
            rows={3}
            fullWidth
        />
        <NumberInput source="price" label="Prix (€)" validate={required()} />
        <BooleanInput source="active" label="Active" defaultValue={true} />
        <NumberInput source="position" label="Position" validate={required()} />
    </>
);

export const BoxOptionList = (props) => (
    <List
        {...props}
        filters={filters}
        bulkActionButtons={false}
        sort={{ field: 'position', order: 'ASC' }}
        perPage={50}
        pagination={<AdminPagination />}
        exporter={false}
    >
        <AdminSelectableDatagrid>
            <NumberField source="position" label="#" />
            <TextField source="name" label="Option" />
            <TextField source="description" label="Description" />
            <NumberField source="price" label="Prix (€)" options={{ minimumFractionDigits: 2, maximumFractionDigits: 2 }} />
            <BooleanField source="active" label="Active" />
            <EditButton />
            <HumanDeleteButton fields={["name"]} fallback="cette option" />
        </AdminSelectableDatagrid>
    </List>
);

export const BoxOptionEdit = (props) => (
    <Edit {...props} mutationMode="optimistic" title={<HumanRecordTitle fields={["name"]} fallback="Option Box" />}>
        <SimpleForm redirect="list">
            <OptionForm />
        </SimpleForm>
    </Edit>
);

export const BoxOptionCreate = (props) => (
    <Create {...props}>
        <SimpleForm redirect="list">
            <OptionForm />
        </SimpleForm>
    </Create>
);
